export default class ScrollInAnimation {
    constructor() {
        this.scrolls = document.querySelectorAll('.scroll-from-left-me');
        if (!this.scrolls) return;
        // this.isMobile = window.innerWidth < 992;
        this.init();
    }

    init() {
        // Observer for fade-in-me effect
        const observer = new IntersectionObserver((entries) => {
            entries.map((entry, index) => {
                if (entry.isIntersecting) {
                    if (entry.target.classList.contains('scroll-from-left-me')) {
                        setTimeout(() => {
                            entry.target.classList.add('is-in-view');
                            observer.unobserve(entry.target);
                        }, 250 * index);
                    }
                }
            });
        }, {});
		Array.from(this.scrolls).map(el => observer.observe(el));
    }
}
